"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDialogStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeDialogStyles = function makeDialogStyles(_ref) {
  var _objectSpread2, _paper;

  var breakpoints = _ref.breakpoints,
      paletteType = _ref.paletteType,
      primitives = _ref.primitives,
      tokens = _ref.tokens;
  var filterColor = paletteType === "light" ? "invert(0%)" : "invert(100%)";
  var spacings = primitives.spacings;
  var closeButtonDimensions = {
    sm: {
      iconSize: spacings["6"],
      distanceToEdge: spacings["4"]
    },
    md: {
      iconSize: spacings["7"],
      distanceToEdge: spacings["5"]
    },
    lg: {
      iconSize: spacings["8"],
      distanceToEdge: spacings["6"]
    },
    xl: {
      iconSize: spacings["8"],
      distanceToEdge: spacings["7"]
    },
    horizontalPadding: spacings["3"],
    verticalPadding: spacings["2"]
  };
  var paperVerticalMarginSmall = parseInt(closeButtonDimensions.sm.iconSize, 10) + parseInt(closeButtonDimensions.verticalPadding) * 2 + parseInt(closeButtonDimensions.sm.distanceToEdge) * 2 + "px";

  var paperHorizontalMargin = function paperHorizontalMargin(breakpoint) {
    return parseInt(closeButtonDimensions[breakpoint].iconSize, 10) + parseInt(closeButtonDimensions.horizontalPadding, 10) * 2 + parseInt(closeButtonDimensions[breakpoint].distanceToEdge, 10) * 2 + "px";
  };

  var closeButtonStyles = {
    color: tokens.colors["fill-primary"].rgb,
    backgroundColor: primitives.colors.detail.transparent,
    borderRadius: primitives.borderRadii.medium,
    padding: "".concat(closeButtonDimensions.verticalPadding, " ").concat(closeButtonDimensions.horizontalPadding),
    position: "absolute",
    top: closeButtonDimensions.sm.distanceToEdge,
    right: closeButtonDimensions.sm.distanceToEdge,
    "&:hover": {
      backgroundColor: tokens.colors["hover-fill-subtle"].rgb
    },
    "&:focus": {
      boxShadow: tokens.effects["focus-ring"].boxShadow
    },
    "&:focus:active": {
      backgroundColor: tokens.colors["pressed-fill-subtle"].rgb,
      boxShadow: "none"
    },
    "&:active": {
      backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
    },
    "& svg": {
      height: closeButtonDimensions.sm.iconSize,
      width: closeButtonDimensions.sm.iconSize
    }
  };
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          transition: "all ".concat(primitives.transitions.easing.smooth, " ").concat(primitives.transitions.duration["3"], " !important"),
          "&.DhigModal--backdrop--default": {
            backgroundColor: tokens.colors["backdrop-60"].rgb
          },
          "&.DhigModal--backdrop--light": {
            backgroundColor: tokens.colors["backdrop-30"].rgb
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        container: {
          transition: "all ".concat(primitives.transitions.easing["slow-down"], " ").concat(primitives.transitions.duration["2"], " ").concat(primitives.transitions.duration["1"], " !important")
        },
        root: {
          '& [class*="MuiPaper-root"]': {
            color: "".concat(tokens.colors["ink-on-background"].rgb)
          }
        },
        paper: (_paper = {
          background: tokens.colors["fill-elevation-1"].rgb,
          borderRadius: primitives.borderRadii.large,
          boxShadow: tokens.effects["elevation-1"].boxShadow
        }, _defineProperty(_paper, breakpoints.down(breakpoints.values.md), {
          marginBottom: paperVerticalMarginSmall,
          marginTop: paperVerticalMarginSmall
        }), _defineProperty(_paper, breakpoints.up(breakpoints.values.md), {
          marginLeft: paperHorizontalMargin("md"),
          marginRight: paperHorizontalMargin("md")
        }), _defineProperty(_paper, breakpoints.up(breakpoints.values.lg), {
          marginLeft: paperHorizontalMargin("lg"),
          marginRight: paperHorizontalMargin("lg")
        }), _defineProperty(_paper, breakpoints.up(breakpoints.values.xl), {
          marginLeft: paperHorizontalMargin("xl"),
          marginRight: paperHorizontalMargin("xl")
        }), _defineProperty(_paper, "&.DhigModal--type--lightbox", {
          boxShadow: tokens.effects["container-0-outside"].boxShadow
        }), _defineProperty(_paper, "&.DhigModal--type--modal", _defineProperty({}, breakpoints.down(breakpoints.values.md), {
          position: "fixed",
          bottom: 0,
          margin: 0,
          width: "100% !important"
        })), _defineProperty(_paper, '& .DhigModal--closeButton--default ~ [class*="MuiDialogTitle-root"]', {
          paddingRight: spacings["9"]
        }), _defineProperty(_paper, "& .DhigModal--closeButton--default", closeButtonStyles), _defineProperty(_paper, "& .DhigModal--closeButton--outside", _objectSpread(_objectSpread({}, closeButtonStyles), {}, (_objectSpread2 = {
          position: "fixed",
          "& svg svg": {
            filter: "invert(100%)",
            height: closeButtonDimensions.sm.iconSize,
            width: closeButtonDimensions.sm.iconSize
          }
        }, _defineProperty(_objectSpread2, breakpoints.up(breakpoints.values.md), {
          top: closeButtonDimensions.md.distanceToEdge,
          right: closeButtonDimensions.md.distanceToEdge,
          "& svg": {
            height: closeButtonDimensions.md.iconSize,
            width: closeButtonDimensions.md.iconSize
          }
        }), _defineProperty(_objectSpread2, breakpoints.up(breakpoints.values.lg), {
          top: closeButtonDimensions.lg.distanceToEdge,
          right: closeButtonDimensions.lg.distanceToEdge,
          "& svg": {
            height: closeButtonDimensions.lg.iconSize,
            width: closeButtonDimensions.lg.iconSize
          }
        }), _defineProperty(_objectSpread2, breakpoints.up(breakpoints.values.xl), {
          top: closeButtonDimensions.xl.distanceToEdge,
          right: closeButtonDimensions.xl.distanceToEdge,
          "& svg": {
            height: closeButtonDimensions.xl.iconSize,
            width: closeButtonDimensions.xl.iconSize
          }
        }), _objectSpread2))), _paper),
        paperWidthXs: {
          maxWidth: 342
        },
        paperWidthSm: {
          maxWidth: 586
        },
        paperWidthMd: {
          maxWidth: 830
        },
        paperWidthLg: {
          maxWidth: 1074
        },
        paperWidthXl: {
          maxWidth: 1318
        },
        paperScrollPaper: _defineProperty({}, breakpoints.down(breakpoints.values.md), {
          maxHeight: "calc(100% - calc(".concat(paperVerticalMarginSmall, " * 2))")
        })
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.typography["headline-small"]), {}, {
          padding: "".concat(spacings["6"], " ").concat(spacings["7"]),
          "& .DhigModal--logo": {
            filter: filterColor,
            height: "24px",
            width: "148px"
          },
          "&.DhigModal--styleVariant--subdivision": {
            boxShadow: tokens.effects["divider-0-bottom"].boxShadow
          }
        })
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "".concat(spacings["0"], "  ").concat(spacings["7"], " ").concat(spacings["6"]),
          "&.DhigModal--styleVariant--subdivision": {
            padding: "".concat(spacings["6"], " ").concat(spacings["7"])
          },
          "&.DhigModal--type--alert [class*='MuiSvgIcon-root']": {
            height: primitives.spacings["8"],
            paddingBottom: "1em",
            width: primitives.spacings["8"]
          },
          "&.DhigModal--type--lightbox": {
            padding: spacings["0"],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& :first-of-type": {
              maxWidth: "100%",
              maxHeight: "100%"
            }
          },
          "&.DhigModal--type--alert": {
            padding: spacings["6"],
            "& img": {
              marginBottom: spacings["4"],
              height: "48px",
              width: "48px"
            }
          }
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "".concat(spacings["6"], " ").concat(spacings["7"]),
          "&.DhigModal--styleVariant--subdivision": {
            boxShadow: tokens.effects["divider-0-top"].boxShadow
          }
        }
      }
    }
  };
};

exports.makeDialogStyles = makeDialogStyles;